import { Theme } from "@mui/material/styles";
import { SystemStyleObject, alpha } from "@mui/system";

const storeDetailsStyles = {
  container: (theme: Theme): SystemStyleObject<Theme> => ({
    display: "flex",
    flexDirection: "column",
    position: "relative",
    top: -20,
    zIndex: 99,

    [theme.breakpoints.down("sm")]: {
      top: 0,
      mt: 3,
    },
  }),
  wrapper: (theme: Theme): SystemStyleObject<Theme> => ({
    backgroundColor: alpha(theme.palette.background.default, 0.6),
    pt: 3,
    pb: 3,
    mb: 4,
    mt: 0,
  }),
};

export default storeDetailsStyles;
